interface HeroBannerProps {
    el: HTMLDivElement;
}

const HERO_BANNER_AWARDS_CONTAINER_CLASS = 'hero-banner-award-container';

const HeroBanner = ({ el }: HeroBannerProps): void => {
    // Dynamically add padding to the next section if awards container exists.
    const nextSibling = el.nextElementSibling;
    const hasNextSectionSibling = nextSibling?.nodeName === 'SECTION';
    const hasAwardsContainer = el.querySelectorAll(`.${HERO_BANNER_AWARDS_CONTAINER_CLASS}`).length > 0;
    const shouldAddPadding = hasNextSectionSibling && hasAwardsContainer;
    if (shouldAddPadding) {
        nextSibling.classList.add('compensate-overflow-top');
    }
};

export default HeroBanner;
